import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useEffect } from "react";

import { Groups } from "src/auth/types/userToken";
import { isUserOnlyMemberOfGroups } from "src/auth/utils/canTakeAction";
import { useLocalPracticeId } from "src/auth/utils/practice";
import { HARDCODED_PAYMENT_TEAM_ID } from "src/common/constants";
import { PaymentsNavPanelKeys } from "src/payments/components/NavPanelPayments";

const PracticeHome: NextPage = () => {
  const router = useRouter();
  const activePracticeId = useLocalPracticeId();

  useEffect(() => {
    if (activePracticeId !== null) {
      if (isUserOnlyMemberOfGroups([Groups.RCM_OCC_HEALTH])) {
        router.replace(
          `/${activePracticeId}/teams/${HARDCODED_PAYMENT_TEAM_ID}?wid=${PaymentsNavPanelKeys.OCC_HEALTH_ORGANIZATIONS}`
        );
      } else {
        router.replace(`/${activePracticeId}/teams`);
      }
    }
  }, [activePracticeId, router]);

  return null;
};

export default PracticeHome;
